import { TablePagination } from '@mui/material';

export interface PaginationProps {
  /**
   * The options for number of rows per page
   * @default '[5, 10, 25]'
   */
  rowsPerPageOptions?: number[];
  /**
   * The selected number of rows per page
   */
  rowsPerPage: number;
  /**
   * The current page number
   */
  page: number;
  /**
   * The total number of records
   */
  count: number;
  /**
   * The function to call when the page number or rows per page changes
   */
  onPaginationOrSort: (parameters: {
    property?: string;
    page?: number;
    rowsPerPage?: number;
  }) => void;
}

export const Pagination = ({
  count,
  page,
  rowsPerPageOptions = [5, 10, 25],
  rowsPerPage = 5,
  onPaginationOrSort,
}: PaginationProps) => {
  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count || 0}
      rowsPerPage={rowsPerPage || 10}
      page={page || 0}
      onPageChange={(_event, page) => {
        onPaginationOrSort({ page: page });
      }}
      onRowsPerPageChange={event => {
        onPaginationOrSort({ rowsPerPage: +event.target.value });
      }}
      sx={{
        position: 'sticky',
        left: 0,
        bottom: 0,
        zIndex: 2,
      }}
    />
  );
};
